import { Button } from 'antd';
import styled from 'styled-components';

export const StyledDebugPanel = styled.div<{ $collapsed: boolean }>`
  position: fixed;
  top: 1rem;
  left: 1rem;
  width: ${({ $collapsed }) => ($collapsed ? 'auto' : '22rem')};
  max-height: ${({ $collapsed }) => ($collapsed ? 'none' : '80vh')};
  display: flex;
  flex-direction: column;
  background: var(--debug-panel-bg);
  border: 1px solid var(--debug-panel-border);
  border-radius: 0.5rem;
  color: #f9fafb;
  font-size: 0.75rem;
  font-family: "SFMono-Regular", Consolas, monospace;
  z-index: 10000;
  overflow: hidden;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--debug-panel-border);

  span {
    font-weight: 600;
    white-space: nowrap;
  }

  div {
    display: flex;
    align-items: center;
    gap: 0.375rem;
  }
`;

export const StyledToggleButton = styled(Button)<{ $collapsed: boolean }>`
  .anticon {
    display: flex;
    transition: transform 0.15s ease;
    transform: rotate(${({ $collapsed }) => ($collapsed ? '-90deg' : '90deg')});
  }
`;

export const StyledLog = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`;

export const StyledEntry = styled.details<{ $direction: 'in' | 'out' | 'system' }>`
  border: 1px solid var(--debug-panel-border);
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;

  summary {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    cursor: pointer;
    list-style: none;
  }

  summary::-webkit-details-marker {
    display: none;
  }

  pre {
    margin: 0.375rem 0 0;
    white-space: pre-wrap;
    word-break: break-word;
    color: #d1d5db;
  }

  .badge {
    color: ${({ $direction }) =>
      $direction === 'in' ? 'var(--debug-in)' : $direction === 'out' ? 'var(--debug-out)' : 'var(--debug-system)'};
    font-weight: 700;
  }

  .time {
    color: #9ca3af;
    margin-left: auto;
  }

  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    margin-top: 0.25rem;
  }

  .tag {
    background: var(--debug-panel-border);
    border-radius: 0.25rem;
    padding: 0.063rem 0.375rem;
    color: #e5e7eb;
  }
`;

export const StyledSender = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding: 0.5rem;
  border-top: 1px solid var(--debug-panel-border);

  textarea {
    resize: vertical;
    font-family: inherit;
  }
`;
